import { Building2, Link2, MapPin, Truck, User, Users, Wallet } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { useDialogs } from "@/lib/dialogs";
import { Pricing } from "@/components/portal/Pricing";
import { AyndriLogo } from "@/components/brand/AyndriLogo";

const KPIS = [[Users, "20", "Planning companies"], [User, "50", "Freelancers"], [Building2, "30", "Partner venues"], [Truck, "100", "Service partners"], [Wallet, "10+", "Paying tenants"], [MapPin, "2", "Pilot states"]];
const OUTCOMES = ["Quick India-first planner onboarding", "Company and freelancer inclusion", "Multilingual inquiry accessibility", "Existing CRM, ERP and sourcing reused", "Tenant isolation and governance", "Clear path from India to UAE"];

export const BottomGrid = () => {
  const { t } = useI18n();
  return (
    <div className="bottom-grid" id="pricing">
      <Pricing />
      <section className="panel" id="india" data-testid="india-rollout-section">
        <h2 className="panel-title">{t("rollout_title")}</h2>
        <div className="target-grid">{KPIS.map(([Icon, v, l]) => <div key={l} className="kpi"><Icon className="ic" /><b>{v}</b><span>{l}</span></div>)}</div>
        <p className="fineprint" style={{ margin: "12px 0 0" }}>Wave 1: Telangana + Andhra Pradesh → Karnataka, Tamil Nadu → Maharashtra, Delhi NCR, Rajasthan → UAE. These figures are targets, not achieved results.</p>
      </section>
      <section className="panel outcome-panel" data-testid="outcomes-section">
        <h2 className="panel-title">{t("outcomes_title")}</h2>
        <ul className="outcomes">{OUTCOMES.map((o) => <li key={o}>{o}</li>)}</ul>
      </section>
    </div>
  );
};

export const FinalCta = () => {
  const open = useDialogs();
  return (
    <section className="finalcta" id="integration" data-testid="integration-section">
      <div>
        <span className="eyebrow" style={{ color: "#deb66d" }}>ONE FRONT DOOR · EXISTING OPERATIONS</span>
        <h2>Connect Ayndri to your Event Management application.</h2>
        <p>The portal handles go-to-market and onboarding; the existing ARGOV-ThreadOne platform remains the source of truth for operational workflows.</p>
      </div>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <button className="btn gold" onClick={() => open("connect")} data-testid="cta-connection-status-button">Connection Status <Link2 className="ic" /></button>
        <button className="btn clear" onClick={() => open("launcher")} data-testid="cta-explore-launcher-button">Explore Launcher</button>
      </div>
    </section>
  );
};

export const Footer = () => {
  const open = useDialogs();
  return (
    <footer className="foot" data-testid="site-footer">
      <div className="foot-brand"><AyndriLogo markSize={34} testId="footer-logo" /><span>AYNDRI.COM · India-first commercial pilot · SaaS portal</span></div>
      <div className="footlinks">
        <button onClick={() => open("connect")} data-testid="footer-integration-button">Integration status</button>
        <button onClick={() => open("launcher")} data-testid="footer-launcher-button">Existing app launcher</button>
        <button onClick={() => open("onboard")} data-testid="footer-join-button">Join pilot</button>
      </div>
      <div>© 2026 Ayndri · Pre-release · Not production</div>
    </footer>
  );
};
